/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Action, State } from '../redux';

const initialState: State['callDetails'] = null;

export function callReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_CALL_DETAIL':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
